import React from 'react';
import '../styles/menuSubTabs.css';

/**
 * The sub categories of the selected menu category, shown as one wrapping group of touch-sized chips
 * (no horizontal scrolling, no arrows): every sub category is always visible and selectable, and the
 * product grid below simply moves down when there are several rows of them.
 */
const TakeawayTabs = ({ tabs, activeIndex, onTabChange }) => (
  <div className="mSectionTopCol menuSubTabs" role="tablist" aria-label="Sub categories">
    {tabs.map((tab, index) => {
      const active = index === activeIndex;
      return (
        <button
          key={tab.category_id}
          className={`menuSubTab${active ? ' active' : ''}`}
          id={`tab-${tab.category_slug}`}
          type="button"
          role="tab"
          aria-controls={`content-${tab.category_slug}`}
          aria-selected={active ? 'true' : 'false'}
          onClick={() => onTabChange(index)}
        >
          <span className="menuSubTabLabel">{tab.category_name}</span>
        </button>
      );
    })}
  </div>
);

export default TakeawayTabs;
